module.exports = __webpack_public_path__ + "img/attachments-icon.1dcf09c1.svg";